import {Obj, Str} from '@shared/api/core/api_schema';

export const WEBSITE_BACKEND_API = {
  '/get-db-url': {
    POST: {
      req: Obj({version: Str()}),
      res: Obj({url: Str()}),
    },
  },
};
